import { ReferralStatus, UrgencyType } from '@app/api-module/control-centre-api-client';
import { ModalityType } from '@app/shared/model/shared.model';
import { Interval } from 'luxon';

const ReferralFiltersActionsPrefix = '[Referral Filters] ';

export class UpdateFilters {
    static readonly type = ReferralFiltersActionsPrefix + 'Update Filters';

    constructor(public modalities: ModalityType[], public urgencies: UrgencyType[], public statuses: ReferralStatus[]) {}
}

export class UpdateTimeRangeFilter {
    static readonly type = ReferralFiltersActionsPrefix + 'Update Filtered Time Range';

    constructor(public timeRangeFilter: Interval) {}
}

export class ClearFilters {
    static readonly type = ReferralFiltersActionsPrefix + 'Clear Filters';
}
